import React,{useEffect,useState} from 'react';
import { Container, Row, Col, Card, ListGroup, Button } from 'react-bootstrap';
import {get_user_detais} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import _ from "lodash"
import FileIcon  from './FileIcon';
const AgentDetails = ({backAction,selected_user}) => {
  const [details,setDetails] = useState(null)
  const get_details = ()=>{
    let post_data ={
        "user_id":selected_user["id"]
    }
    postMethod(get_user_detais,post_data).then((res)=>{
        let result = _.get(res,"result",null)
        if(_.get(res,"result.passport")){
          try{

          
            const jsonString = _.get(res,"result.passport");            
            result["passport"] = JSON.parse(jsonString)
            console.log(result["passport"])
          }catch(e){
            console.log(e)
          }
            
        }
        if(_.get(res,"result.selfie")){

          try{
          
            const jsonString = _.get(res,"result.selfie");            
            result["selfie"] = JSON.parse(jsonString)
          }
            catch(e){
              console.log(e)
            }
            
            
        }
        if(_.get(res,"result.aadhaar_card")){
          try{
            const jsonString = _.get(res,"result.aadhaar_card");            
            result["aadhaar_card"] = JSON.parse(jsonString);
          }
            catch(e){
              console.log(e)
            }
            
            
        }
        if(_.get(res,"result.upload_check")){
          try{
            const jsonString = _.get(res,"result.upload_check");            
            result["upload_check"] = JSON.parse(jsonString);
          }
            catch(e){
              console.log(e)
            }
            
            
        }
        setDetails(result)
      })

  }
  useEffect(()=>{
    get_details()
  },[selected_user]);

  return (
    <div className="mt-3">
      <Row className="mb-4">
        <Col md={12}>
          {/* Contact Details */}
          <Card className="mb-4 subscriberDetails">
            {/* <Card.Header as="h5">Contact Details</Card.Header> */}
            <Card.Body className="bg-white">
              <ListGroup variant="flush">
                <div class="row">
                  <div class="col-md-3"><ListGroup.Item>
                    <strong>First Name:</strong><br /> <span>{_.get(details,"first_name")}</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Last Name:</strong><br /> <span>{_.get(details,"last_name")}</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Email:</strong><br /> <span>{_.get(details,"email")}</span>
                    </ListGroup.Item>
                  </div>

                  {_.get(details,"mobile_no","") && <div class="col-md-3"><ListGroup.Item>
                    <strong>Mobile No:</strong><br /> <span>{_.get(details,"mobile_no")}</span>
                  </ListGroup.Item>
                  </div>
                  }
                   {_.get(details,"aternate_mobile_no","") && <div class="col-md-3"><ListGroup.Item>
                    <strong>Aternate Mobile No:</strong><br /> <span>{_.get(details,"aternate_mobile_no")}</span>
                  </ListGroup.Item>
                  </div>
                  }
                  {_.get(details,"date_of_birth","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Date of Birth:</strong><br /> <span>{_.get(details,"date_of_birth")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                  {_.get(details,"gender","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Gender:</strong><br /> <span>{_.get(details,"gender")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                  {_.get(details,"admin_tenant_details.name","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Branch:</strong><br /> <span>{_.get(details,"admin_tenant_details.name")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                  
                  
                  
                </div>
                <div class="row">
                {_.get(details,"country_details.name","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Country:</strong><br /> <span>{_.get(details,"country_details.name")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                   {_.get(details,"state_details.name","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>State:</strong><br /> <span>{_.get(details,"state_details.name")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                   {_.get(details,"location_details.name","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Location:</strong><br /> <span>{_.get(details,"location_details.name")}</span>
                    </ListGroup.Item>
                  </div>
                  }

                 {_.get(details,"present_address","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Present Address:</strong><br /> <span>{_.get(details,"present_address")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                  {_.get(details,"pincode","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Pincode:</strong><br /> <span>{_.get(details,"pincode")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                  {_.get(details,"present_occupation","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Present Occupation:</strong><br /> <span>{_.get(details,"present_occupation")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                  {_.get(details,"employer_name","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Employer Name:</strong><br /> <span>{_.get(details,"employer_name")}</span>
                    </ListGroup.Item>
                  </div>
                  }
                   {_.get(details,"qualification","") && <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Qualification:</strong><br /> <span>{_.get(details,"qualification")}</span>
                    </ListGroup.Item>
                  </div>
                  }

                </div>
            
            { (_.get(details,"account_holder_name","")|| _.get(details,"bank_account_number","") || _.get(details,"bank_name","")|| _.get(details,"ifsc_code","") )&&  <div class="row">
                <div class="col-md-12 mb-3"> <div class="p-1 border bg-light text-center">Bank Details </div></div>

                    {_.get(details,"account_holder_name","") && <div class="col-md-3">
                        <ListGroup.Item>
                        <strong>Account Holder Name:</strong><br /> <span>{_.get(details,"account_holder_name")}</span>
                        </ListGroup.Item>
                    </div>
                    }
                    {_.get(details,"bank_account_number","") && <div class="col-md-3">
                    <ListGroup.Item>
                    <strong>Account Number:</strong><br /> <span>{_.get(details,"bank_account_number")}</span>
                    </ListGroup.Item>
                    </div>
                    }
                    {_.get(details,"bank_name","") && <div class="col-md-3">
                    <ListGroup.Item>
                    <strong>Bank Name:</strong><br /> <span>{_.get(details,"bank_name")}</span>
                    </ListGroup.Item>
                    </div>
                    }
                     {_.get(details,"ifsc_code","") && <div class="col-md-3">
                    <ListGroup.Item>
                    <strong>IFSC Code:</strong><br /> <span>{_.get(details,"ifsc_code")}</span>
                    </ListGroup.Item>
                    </div>
                    }
                    </div>
                    }
                {(
                   ( _.get(details,"passport.file_name") &&  _.get(details,"passport.path")  )
                || ( _.get(details,"aadhaar_card.file_name") && _.get(details,"aadhaar_card.path") )
                 || (_.get(details,"selfie.file_name") && _.get(details,"selfie.path"))
                 || ( _.get(details,"upload_check.file_name") && _.get(details,"upload_check.path") )
                 ) &&<div class="row">
                    <div class="col-md-12 mb-3"> <div class="p-1 border bg-light text-center">Documents </div></div>


                    {

                    (_.get(details,"passport.file_name") &&  _.get(details,"passport.path")) && <div class="col-md-3">
                    PAN Card: {_.get(details,"passport.file_name")}
                    <FileIcon fileName={_.get(details,"passport.file_name")} fileBase64={_.get(details,"passport.path")} /> 

                    </div>

                    }
                    {

                    (_.get(details,"aadhaar_card.file_name") &&  _.get(details,"aadhaar_card.path")) && <div class="col-md-3">
                    Aadhaar Card: {_.get(details,"aadhaar_card.file_name")}
                    <FileIcon fileName={_.get(details,"aadhaar_card.file_name")} fileBase64={_.get(details,"aadhaar_card.path")} /> 

                    </div>

                    }
                    {
                    (_.get(details,"selfie.file_name") &&  _.get(details,"selfie.path")) && <div class="col-md-3">
                    Selfie: {_.get(details,"selfie.file_name")}
                    <FileIcon fileName={_.get(details,"selfie.file_name")} fileBase64={_.get(details,"selfie.path")} /> 
                    
                    </div>
                         
                    }
                    {
                    (_.get(details,"upload_check.file_name") &&  _.get(details,"upload_check.path")) && <div class="col-md-3">
                    Cheque: {_.get(details,"upload_check.file_name")}
                    <FileIcon fileName={_.get(details,"upload_check.file_name")} fileBase64={_.get(details,"upload_check.path")} /> 
                    
                    </div>
                         
                    }
                    
                </div>
                }
                {/* <div class="row">
                  <div class="col-md-3"><ListGroup.Item>
                    <strong>Mobile No:</strong><br /> <span>9666004759</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Enquiry:</strong><br /> <span>Home loan</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Amount:</strong><br /> <span>120000</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Lead Source:</strong><br /> <span>Agent</span>
                    </ListGroup.Item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3"><ListGroup.Item>
                    <strong>Proffesion Type:</strong><br /> <span>Salaried</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Eligible:</strong><br /> <span>Yes</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Eligible Type:</strong><br /> <span>Home Loan</span>
                    </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Loan Eligible Amount:</strong><br /> <span>1200000</span>
                    </ListGroup.Item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3"><ListGroup.Item>
                    <strong>Foir:</strong><br /> <span>Salaried</span>
                  </ListGroup.Item>
                  </div>
                  <div class="col-md-3">
                    <ListGroup.Item>
                      <strong>Eligible:</strong><br /> <span>Yes</span>
                    </ListGroup.Item>
                  </div>
                  
                </div> */}
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AgentDetails;
